// extracted by mini-css-extract-plugin
module.exports = {"Oblong":"TextGroupSectionB_Oblong__1QrYh","TextContainer":"TextGroupSectionB_TextContainer__217fL"};